import React from "react";

export default function AboutPage() {
    return (
        <main className="container py-4">
            <div className="row">
                <div className="col">
                    <h1>The Old School House</h1>
                    <p className="lead">
                        A simple community mapping project. This site displays public map data and
                        provides a secured data-entry area for contributors.
                    </p>

                    <h2>What we do</h2>
                    <p>
                        We collect and display points of interest on an interactive map. Public users
                        can view the map without signing in. Registered contributors can sign in to
                        add and manage points that appear on the map.
                    </p>

                    <h2>Contact</h2>
                    <p>
                        For questions or to request contributor access, email <a href="mailto:info@oldschoolhouse.example">info@oldschoolhouse.example</a>.
                    </p>
                </div>
            </div>
        </main>
    );
}